module.exports = __webpack_public_path__ + "img/mgh-otemachi.dc9bbd66.jpg";